import { JBEnvironmentId } from '@bjb-gcrm/gcrm-frontend-components';

export const getACAURL = (env: JBEnvironmentId) => {
  switch (env) {
    case 'TST50': {
      return 'https://aca-tst50.juliusbaer.com';
    }
    case 'TST60': {
      return 'https://aca-fe-web-tst60.juliusbaer.com';
    }
    case 'UAT1': {
      return 'https://aca-uat1.juliusbaer.com';
    }
    case 'UAT2': {
      return 'https://aca-uat2.juliusbaer.com/';
    }
    case 'PRD': {
      return 'https://aca.juliusbaer.com';
    }
    default: {
      return '';
    }
  }
};
